import { LocationHelpKind } from '@/views/composables/constants/main/locationHelp.constants';
import { readonly, ref } from 'vue';

export type LocationAskReason = 'boards' | 'checkin' | 'walk' | 'traces';

const SENTENCE_KEY: Record<LocationAskReason, string> = {
  boards: 'location.ask.boards',
  checkin: 'location.ask.checkin',
  walk: 'location.ask.walk',
  traces: 'location.ask.traces',
};

export function locationAskSentenceKey(ask: LocationAskReason): string {
  return SENTENCE_KEY[ask];
}

const APPROXIMATE_SHOWN_KEY = 'gam_location_approximate_shown';

const kind = ref<LocationHelpKind | null>(null);
const askReason = ref<LocationAskReason | null>(null);

export const locationHelpKind = readonly(kind);
export const locationHelpReason = readonly(askReason);

/**
 * The browser refused location. Opens the help modal with the steps to set
 * Location to Allow for this device and browser, and a Reload button.
 * `ask` names the function that was tapped, so the help can say why.
 */
export function notifyLocationDenied(ask?: LocationAskReason) {
  askReason.value = ask ?? null;
  kind.value = LocationHelpKind.BLOCKED;
}

/**
 * Permission is not denied but no position came back, e.g. Safari's "Ask"
 * setting on macOS, which grants and then never delivers a fix.
 */
export function notifyLocationUnavailable(ask?: LocationAskReason) {
  askReason.value = ask ?? null;
  kind.value = LocationHelpKind.UNAVAILABLE;
}

/**
 * The phone only hands out approximate location. Shown once per session and
 * never over the blocked or unavailable help.
 */
export function notifyLocationApproximate() {
  if (kind.value || sessionStorage.getItem(APPROXIMATE_SHOWN_KEY)) return;
  sessionStorage.setItem(APPROXIMATE_SHOWN_KEY, '1');
  kind.value = LocationHelpKind.APPROXIMATE;
}

export function closeLocationHelp(only?: LocationHelpKind[]) {
  if (only && (!kind.value || !only.includes(kind.value))) return;
  kind.value = null;
  askReason.value = null;
}
